import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestCadastroDvec({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'dispositivosinstalacoesdvecs', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteCadastroDvec({ payload }) {
  try {
    const { idcadastrodvec, params } = payload;

    yield call(api.delete, `dispositivosinstalacoesdvecs/${idcadastrodvec}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { cadastrodvec, params } = payload;

    yield call(api.post, 'dispositivosinstalacoesdvecs', cadastrodvec);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/dispositivosinstalacoesdvecs');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idcadastrodvec } = payload;

    const { data } = yield call(
      api.get,
      `dispositivosinstalacoesdvecs/${idcadastrodvec}`
    );
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { cadastrodvec, params } = payload;

    yield call(api.put, 'dispositivosinstalacoesdvecs', cadastrodvec);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/dispositivosinstalacoesdvecs');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'dispositivosinstalacoesdvecs', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@cadastrodvec/CADASTRODVEC_IN_REQUEST', requestCadastroDvec),
  takeLatest('@cadastrodvec/DELETE_CADASTRODVEC', deleteCadastroDvec),
  takeLatest('@cadastrodvec/SUCCESS_REMOVE', requestCadastroDvec),
  takeLatest('@cadastrodvec/STORE_CADASTRODVEC', store),
  takeLatest('@cadastrodvec/FIND_CADASTRODVEC', find),
  takeLatest('@cadastrodvec/UPDATE_CADASTRODVEC', update),
  takeLatest('@cadastrodvec/RECORD_FILTERING', applyedFilters),
]);
